import React from 'react';
//import $ from 'jquery';
import api from '../../../services/api';
import { Modal } from 'react-bootstrap';
import querystring from 'querystring';
import loadingGif from '../../../img/loading-gif.gif';

class PontoVendaForm extends React.Component {

	constructor(props) {
		super(props);

		this.resetForm = this.resetForm.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeInput = this.handleChangeInput.bind(this);
		this.setValidations();

		this.state = {
			apelido: '',
			unidade: '',
			status: '',
			publicKey: '',
			secretKey: '',
			authType: '',
		};

		if (this.props.item) {
			const item = this.props.item;
			this.state = {
				id: item.id,
				apelido: item.apelido,
				unidade: item.unidade ? item.unidade.id : '',
				status: item.status,
				publicKey: item.publicKey,
				secretKey: item.secretKey,
				authType: item.authType,
			};
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.item !== prevProps.item) {
			const item = this.props.item;

			this.setState({
				id: item.id,

				apelido: item.apelido,
				unidade: item.unidade ? item.unidade.id : '',
				status: item.status,
				publicKey: item.publicKey,
				secretKey: item.secretKey,
				authType: item.authType,
			});
		}
	}

	null2Empty(val) {
		if (val == null) return '';
		return val;
	}

	cancelForm() {
		if (this.props.item) {
			const item = this.props.item;

			this.setState({
				id: item.id,

				apelido: item.apelido,
				unidade: item.unidade ? item.unidade.id : '',
				status: item.status,
				publicKey: item.publicKey,
				secretKey: item.secretKey,
				authType: item.authType,
			});
		} else {
			this.resetForm();
		}
	}

	resetForm() {
		this.setState({
			apelido: '',
			unidade: '',
			status: '',
			publicKey: '',
			secretKey: '',
			authType: '',
		});
	}

	handleChangeInput(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
		});
	}

	showErrorMessage(key) {
		if (!this.validations[key] || this.validations[key].valid !== false) return;
		return this.validations[key].message;
	}

	async handleSubmit(e, setModalVisible) {
		const self = this;
		e.preventDefault();

		if (this.state.loading) {
			////console.log('loading');
			return;
		}

		if (!this.validate()) {
			this.forceUpdate();
			return;
		}

		const qsData = querystring.stringify(this.state);
		////console.log(qsData);

		this.setState({ loading: true });

		const options = {
			//method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			//data: x,
			//url: '/admin/unidade',
		};
		try {
			const { data, status } = await api.post(
				'/admin/pontovenda',
				qsData,
				options
			);
			////console.log(data);
			////console.log(status);
			if (data === false) {
				alert('Solicitação inválida');
				return;
			}

			if (data.errors) {
				var keys = Object.keys(data.errors);
				var msgs = '';
				for (var i = 0; i < keys.length; i++) {
					msgs += data.errors[keys[i]] + '\n';
				}

				alert(msgs);
				return;
			}

			if (status === 200 && data.id) {
				if (!self.state.id) {
					//	$('#' + self.props.elementId + 'Elem')[0].reset();
				}

				if (typeof self.props.callback == 'function') {
					self.props.callback(data);
				}

				//$('#' + self.props.elementId).modal('hide');
			}
			setModalVisible(false);
			this.setState({ loading: false });
		} catch (error) {
			//console.log(error);
			
			this.setState({ loading: false });
		}
	}

	validate() {
		var valid = true;
		var keys = Object.keys(this.validations);

		for (var i = 0; i < keys.length; i++) {
			this.validations[keys[i]].valid = this.validations[keys[i]].validator(
				this.state[keys[i]]
			);
			if (!this.validations[keys[i]].valid) {
				valid = false;
				continue;
			}
		}

		return valid;
	}

	setValidations() {
		this.validations = {
			apelido: {
				valid: null,
				message: 'apelido inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			status: {
				valid: null,
				message: 'status inválido',
				validator: (value) => {
					return ['0', '1'].indexOf(String(value)) > -1;
				},
			},
			publicKey: {
				valid: null,
				message: 'chave pública inválida',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			secretKey: {
				valid: null,
				message: 'chave secreta inválida',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			authType: {
				valid: null,
				message: 'tipo de autenticação inválida',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
		};
	}

	render() {
		const props = this.props;
		const pontovenda = this.state;
		const { modalVisible, setModalVisible } = props;
		////console.log(pontovenda);

		return (
			<Modal
				show={modalVisible}
				onHide={() => {
					setModalVisible(false);
				}}>
				<Modal.Header>
					<h2 className='modal-title'>
						{props.item ? 'Editar Ponto de Venda' : 'Novo Ponto de Venda'}
					</h2>
				</Modal.Header>
				<Modal.Body>
					<form
						id={props.elementId + 'Elem'}
						onSubmit={(e) => {
							this.handleSubmit(e, setModalVisible);
							//setModalVisible(false);
						}}>
						<div className='modal-body'>
							<div className='form-group'>
								<label>Apelido</label>
								<input
									className='form-control'
									type='text'
									name='apelido'
									value={pontovenda.apelido}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('apelido')}
								</span>
							</div>
							<div className='form-group'>
								<label>Situação</label>
								<select
									className='form-control'
									name='status'
									value={pontovenda.status}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='0'>Inativo</option>
									<option value='1'>Ativo</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('status')}
								</span>
							</div>
							<div className='form-group'>
								<label>Unidade</label>
								<select
									className='form-control'
									type='text'
									name='unidade'
									value={pontovenda.unidade}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									{props.unidades.map((unidade) => (
										<option value={unidade.id}>
											{unidade.nome} &#35;{unidade.conta.nome}
										</option>
									))}
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('unidade')}
								</span>
							</div>
							<div className='form-group'>
								<label>Tipo Autenticação</label>
								<select
									className='form-control'
									name='authType'
									value={pontovenda.authType}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='AUTH_BASIC'>Básica</option>
									<option value='AUTH_MAMBA'>MAMBA</option>
									<option value='AUTH_HMAC'>HMAC</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('authType')}
								</span>
							</div>
							<div className='form-group'>
								<label>Chave Pública</label>
								<input
									className='form-control'
									type='text'
									name='publicKey'
									value={pontovenda.publicKey}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('publicKey')}
								</span>
							</div>
							<div className='form-group'>
								<label>Chave Secreta</label>
								<input
									className='form-control'
									type='text'
									name='secretKey'
									value={pontovenda.secretKey}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('secretKey')}
								</span>
							</div>
						</div>
						<div className='modal-footer'>
							<button
								type='button'
								onClick={(e) => {
									e.preventDefault();

									this.cancelForm();

									setModalVisible(false);
								}}
								className='btn btn-light border'
								data-dismiss='modal'>
								Cancelar
							</button>
							<button type='submit' className='btn btn-primary'>
								{pontovenda.loading ? (
									<img className='loadingImg' src={loadingGif} alt='loading' />
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		);
	}
}

export default PontoVendaForm;
